import { useWebsiteReferralTracking } from '~/modules/tracking/util/websiteTracking';
import { Button as RoccoButton } from '@archipro/rocco/components/button';

interface PageDetailHeaderCTAProps {
    pageID: number;
    website?: string | null;
    professionalID: number;
    professionalTitle: string;
}

/**
 * The CTA button in the product detail page header.
 */
const PageDetailHeaderCTA = ({
    pageID,
    website,
    professionalID,
    professionalTitle,
}: PageDetailHeaderCTAProps) => {
    const {
        referralTrackingURL,
        referralTrackingClass,
        referralTrackingParams,
    } = useWebsiteReferralTracking(website ?? undefined, {
        libraryItemID: pageID,
        professionalID: professionalID,
        professionalTitle,
    });

    return (
        <div className="flex gap-4">
            {referralTrackingURL && (
                <RoccoButton
                    color="secondary"
                    weight="default"
                    size={'larger'}
                    asChild
                >
                    <a
                        href={referralTrackingURL}
                        target="_blank"
                        rel="noreferrer"
                        className={referralTrackingClass}
                        {...referralTrackingParams}
                    >
                        Visit Website
                    </a>
                </RoccoButton>
            )}
        </div>
    );
};

export default PageDetailHeaderCTA;
